webpackJsonp([98038720393726],{

/***/ 281:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.query = undefined;
	
	var _templateObject = _taggedTemplateLiteralLoose(["\n  align-items: stretch;\n\n  @media (max-width: 30em) {\n    flex-wrap: wrap;\n    > * {\n      width: 100%;\n      margin-bottom: ", "px;\n\n      &:not(:lang(ar)) {\n        margin-left: 0;\n      }\n      &:lang(ar) {\n        margin-right: 0;\n      }\n    }\n    > *:last-child {\n      margin-bottom: ", "px;\n    }\n  }\n  @media (min-width: 30em) and (max-width: 74em) {\n    flex-wrap: wrap;\n    > * {\n      width: ", ";\n      margin-bottom: ", "px;\n\n      &:not(:lang(ar)) {\n        margin-left: ", "px;\n      }\n      &:lang(ar) {\n        margin-right: ", "px;\n      }\n    }\n    > *:nth-child(2n + 1) {\n      &:not(:lang(ar)) {\n        margin-left: 0;\n      }\n      &:lang(ar) {\n        margin-right: 0;\n      }\n    }\n    > *:nth-last-child(-n + 2) {\n      margin-bottom: ", "px;\n    }\n  }\n  @media (min-width: 74em) {\n    flex-wrap: wrap;\n    > * {\n      width: ", ";\n      margin-bottom: ", "px;\n\n      &:not(:lang(ar)) {\n        margin-left: ", "px;\n      }\n      &:lang(ar) {\n        margin-right: ", "px;\n      }\n    }\n    > *:nth-child(3n + 1) {\n      &:not(:lang(ar)) {\n        margin-left: 0;\n      }\n      &:lang(ar) {\n        margin-right: 0;\n      }\n    }\n    > *:nth-last-child(-n + 3) {\n      margin-bottom: ", "px;\n    }\n  }\n"], ["\n  align-items: stretch;\n\n  @media (max-width: 30em) {\n    flex-wrap: wrap;\n    > * {\n      width: 100%;\n      margin-bottom: ", "px;\n\n      &:not(:lang(ar)) {\n        margin-left: 0;\n      }\n      &:lang(ar) {\n        margin-right: 0;\n      }\n    }\n    > *:last-child {\n      margin-bottom: ", "px;\n    }\n  }\n  @media (min-width: 30em) and (max-width: 74em) {\n    flex-wrap: wrap;\n    > * {\n      width: ", ";\n      margin-bottom: ", "px;\n\n      &:not(:lang(ar)) {\n        margin-left: ", "px;\n      }\n      &:lang(ar) {\n        margin-right: ", "px;\n      }\n    }\n    > *:nth-child(2n + 1) {\n      &:not(:lang(ar)) {\n        margin-left: 0;\n      }\n      &:lang(ar) {\n        margin-right: 0;\n      }\n    }\n    > *:nth-last-child(-n + 2) {\n      margin-bottom: ", "px;\n    }\n  }\n  @media (min-width: 74em) {\n    flex-wrap: wrap;\n    > * {\n      width: ", ";\n      margin-bottom: ", "px;\n\n      &:not(:lang(ar)) {\n        margin-left: ", "px;\n      }\n      &:lang(ar) {\n        margin-right: ", "px;\n      }\n    }\n    > *:nth-child(3n + 1) {\n      &:not(:lang(ar)) {\n        margin-left: 0;\n      }\n      &:lang(ar) {\n        margin-right: 0;\n      }\n    }\n    > *:nth-last-child(-n + 3) {\n      margin-bottom: ", "px;\n    }\n  }\n"]),
	    _templateObject2 = _taggedTemplateLiteralLoose(["\n  position: relative;\n  width: 100%;\n  padding-bottom: 100%;\n  background-image: ", ";\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n\n  &:after {\n    /* content: \"\"; */\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1;\n    background: ", ";\n  }\n"], ["\n  position: relative;\n  width: 100%;\n  padding-bottom: 100%;\n  background-image: ", ";\n  background-size: cover;\n  background-position: center;\n  background-repeat: no-repeat;\n\n  &:after {\n    /* content: \"\"; */\n    position: absolute;\n    top: 0;\n    right: 0;\n    bottom: 0;\n    left: 0;\n    z-index: 1;\n    background: ", ";\n  }\n"]);
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _polished = __webpack_require__(8);
	
	var _styledComponents = __webpack_require__(5);
	
	var _styledComponents2 = _interopRequireDefault(_styledComponents);
	
	var _prismicDom = __webpack_require__(10);
	
	var _rebass = __webpack_require__(4);
	
	var _components = __webpack_require__(7);
	
	var _gatsbyLink = __webpack_require__(9);
	
	var _gatsbyLink2 = _interopRequireDefault(_gatsbyLink);
	
	var _invertTheme = __webpack_require__(12);
	
	var _invertTheme2 = _interopRequireDefault(_invertTheme);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function _taggedTemplateLiteralLoose(strings, raw) { strings.raw = raw; return strings; }
	
	var StaffLayout = (0, _styledComponents2.default)(_rebass.Flex)(_templateObject, function (props) {
	  return props.theme.space[1];
	}, function (props) {
	  return props.theme.space[0];
	}, function (props) {
	  return "calc(" + 1 / 2 * 100 + "% - " + props.theme.space[4] / 2 + "px)";
	}, function (props) {
	  return props.theme.space[5];
	}, function (props) {
	  return props.theme.space[4];
	}, function (props) {
	  return props.theme.space[4];
	}, function (props) {
	  return props.theme.space[0];
	}, function (props) {
	  return "calc(" + 1 / 3 * 100 + "% - " + props.theme.space[4] / (1 / 3 + 1) + "px)";
	}, function (props) {
	  return props.theme.space[5];
	}, function (props) {
	  return props.theme.space[4];
	}, function (props) {
	  return props.theme.space[4];
	}, function (props) {
	  return props.theme.space[0];
	});
	
	var StaffPhoto = (0, _styledComponents2.default)(_rebass.Box)(_templateObject2, function (props) {
	  return "url(" + props.backgroundImage + ")";
	}, function (props) {
	  return props.theme.colors.violet && "linear-gradient(to left, " + (0, _polished.rgba)(props.theme.colors.violet, 0.75) + ", " + (0, _polished.rgba)(props.theme.colors.violet, 0.75) + ")";
	});
	
	var StaffMember = function StaffMember(props) {
	  return _react2.default.createElement(
	    _rebass.Box,
	    { is: _gatsbyLink2.default, to: "/" + props.object.lang + "/team/" + props.object.uid },
	    _react2.default.createElement(StaffPhoto, {
	      backgroundImage: props.object.data.header_image.url ? props.object.data.header_image.url : "",
	      alt: "Headshot of " + (props.object.data.title[0] ? props.object.data.title[0].text : ""),
	      mb: 2
	    }),
	    _react2.default.createElement(_components.H3, {
	      children: props.object.data.title[0] ? props.object.data.title[0].text : "",
	      mb: 1
	    }),
	    _react2.default.createElement(_components.H4, {
	      children: props.object.data.subtitle[0] ? props.object.data.subtitle[0].text : ""
	    })
	  );
	};
	
	var BoardMember = function BoardMember(props) {
	  return _react2.default.createElement(
	    _rebass.Box,
	    null,
	    _react2.default.createElement(_components.H3, { children: props.object.name, mb: 1 }),
	    _react2.default.createElement(_components.H4, { children: props.object.position })
	  );
	};
	
	var linkResolver = function linkResolver(doc) {
	  return "/" + doc.type;
	};
	
	var Team = function (_React$Component) {
	  _inherits(Team, _React$Component);
	
	  function Team() {
	    _classCallCheck(this, Team);
	
	    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
	  }
	
	  Team.prototype.componentDidMount = function componentDidMount() {
	    this.context.setAltLanguages(undefined);
	  };
	
	  Team.prototype.render = function render() {
	    var json = "";
	    if (this.props.data.team.raw) {
	      json = JSON.parse(this.props.data.team.raw);
	    }
	    return _react2.default.createElement(
	      _rebass.Box,
	      {
	        style: this.props.transition ? this.props.transition.style : { opacity: 0 }
	      },
	      _react2.default.createElement(_components.Head, { source: json.data }),
	      _react2.default.createElement(
	        _components.Main,
	        null,
	        _react2.default.createElement(
	          _components.PageHeader,
	          { title: json.data.title[0].text, color: json.uid },
	          json.data.subtitle[0] && _react2.default.createElement(_components.H2, { children: json.data.subtitle[0].text, fontSize: [4, 5] }),
	          json.data.description[0] && _react2.default.createElement(_components.Text, { children: json.data.description[0].text })
	        ),
	        _react2.default.createElement(
	          _components.PageSection,
	          null,
	          json.data.body1[0] && _react2.default.createElement(
	            _components.PageSidebar,
	            null,
	            json.data.body1.map(function (callout, index) {
	              return _react2.default.createElement(_components.CalloutCard, {
	                key: "callout" + index,
	                callout: callout.primary,
	                lang: json.lang
	              });
	            })
	          ),
	          _react2.default.createElement(
	            _components.PageContent,
	            null,
	            _react2.default.createElement(
	              _rebass.Box,
	              { mb: 6 },
	              _react2.default.createElement(_components.H2, {
	                children: json.lang === "en-us" ? "Staff Directory" : json.lang === "es-mx" ? "Directorio del equipo" : "دليل فريق المركز"
	              })
	            ),
	            this.props.data.staff && _react2.default.createElement(
	              _rebass.Box,
	              null,
	              _react2.default.createElement(
	                StaffLayout,
	                null,
	                this.props.data.staff.edges.sort(function (a, b) {
	                  if (a.node.data) {
	                    if (a.node.data.title[0].text.split(" ")[1] < b.node.data.title[0].text.split(" ")[1]) return -1;
	                    if (a.node.data.title[0].text.split(" ")[1] > b.node.data.title[0].text.split(" ")[1]) return 1;
	                  }
	                  return 0;
	                }).map(function (member, index) {
	                  return _react2.default.createElement(StaffMember, {
	                    key: "staffMember" + index,
	                    object: member.node
	                  });
	                })
	              )
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _styledComponents.ThemeProvider,
	          { theme: _invertTheme2.default },
	          _react2.default.createElement(
	            _components.PageSection,
	            { style: { backgroundColor: "#7673c0" } },
	            _react2.default.createElement(
	              _components.PageContent,
	              null,
	              _react2.default.createElement(
	                _rebass.Box,
	                { mb: [5, 6] },
	                json.data.board_header[0] && _react2.default.createElement(_components.H2, { children: json.data.board_header[0].text }),
	                json.data.board_description && _react2.default.createElement(_components.Article, {
	                  dangerouslySetInnerHTML: {
	                    __html: _prismicDom.RichText.asHtml(json.data.board_description, linkResolver)
	                  }
	                })
	              ),
	              _react2.default.createElement(
	                _rebass.Box,
	                null,
	                _react2.default.createElement(
	                  StaffLayout,
	                  null,
	                  json.data.board.map(function (boardMember, index) {
	                    return _react2.default.createElement(BoardMember, {
	                      key: "boardMember" + index,
	                      object: boardMember
	                    });
	                  })
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Team;
	}(_react2.default.Component);
	
	Team.contextTypes = {
	  setAltLanguages: _propTypes2.default.func
	};
	exports.default = Team;
	var query = exports.query = "** extracted graphql fragment **";

/***/ })

});


// WEBPACK FOOTER //
// component---src-layouts-team-js-73cfa1d0089046fab18e.js